export const INDEX_ROBOTS_DIRECTIVE = "index, follow";
export const NOINDEX_ROBOTS_DIRECTIVE = "noindex, nofollow";
